import { axios, getToken } from "../../../settings";
import { nativeLoginUrl } from "../api";
import { push } from "connected-react-router";

export function handleLoginResponse(dispatch, payload) {
  if (!payload || payload?.error) {
    let message;
    if (!payload) {
      message = "Network error";
    } else if (payload.message) {
      message = payload.message;
    } else {
      message = JSON.stringify(payload);
    }
    payload = { error: true, message };
  } else if (payload?.status === 429) {
    const message =
      payload?.data?.message ||
      "Request limit exceeded, due to security reasons you will need to wait before trying again.";
    payload = { error: true, message };
  }
  dispatch({ type: "NATIVE_LOGIN", payload });
}

export const LoginAction = (payload, enqueueSnackbar) => async (dispatch) => {
  dispatch({ type: "SET_LOGIN_RESPONSE", payload: null });
  dispatch({ type: "SHOW_LOGIN_LOADER" });
  await axios
    .post(nativeLoginUrl(), { ...payload })
    .then(async function ({ data: x }) {
      dispatch({ type: "HIDE_LOGIN_LOADER" });
      if (x) {
        if (x.error) {
          enqueueSnackbar(`Login failed. ${x.message}`, {
            variant: "error",
          });
          return;
        }
        if (x && x.data && x.data.autho_token) {
          sessionStorage.setItem("tokenAdmin", x.data.autho_token);
          // document.cookie =  `firstSessionId=${x.data.autho_token}`;

          dispatch({ type: "SET_FIRSTLOGIN", login: x.data.firstLogin });
        }

        dispatch({ type: "NATIVE_LOGIN", payload: x });
      }
    })
    .catch(function ({ response: x }) {
      dispatch({ type: "HIDE_LOGIN_LOADER" });
      if (x) {
        if (x && x.data && x.message) {
          dispatch({
            type: "NATIVE_LOGIN",
            payload: { error: true, message: x.message },
          });
        } else if (x.status == "500") {
          dispatch({
            type: "NATIVE_LOGIN",
            payload: { error: true, message: x.statusText },
          });
        } else
          dispatch({
            type: "NATIVE_LOGIN",
            payload: { error: true, message: JSON.stringify(x) },
          });
      } else {
        dispatch({
          type: "NATIVE_LOGIN",
          payload: { error: true, message: "Network error." },
        });
      }
    });
};

// Two-factor authentication timer action creators
export const startTwoFactorTimer = () => ({
  type: "START_TWO_FACTOR_TIMER",
});

export const clearTwoFactorTimer = () => ({
  type: "CLEAR_TWO_FACTOR_TIMER",
});

export const twoFactorTimeout = () => ({
  type: "TWO_FACTOR_TIMEOUT",
});
